import { Grid, List } from "react-feather";
import { useAppDispatch } from "../../../ReduxToolkit/Hooks";
import { setGridView } from "../../../ReduxToolkit/Reducers/BookmarkTabSlice";
import { Href } from "../../../Constants/Constants";
import { LI, UL } from "../../../AbstractElements";

const ViewBookmark = () => {
  const dispatch = useAppDispatch();

  return (
    <UL className="simple-list flex-row">
      <LI>
        <a className="grid-bookmark-view" href={Href}>
          <Grid onClick={() => dispatch(setGridView(true))} />
        </a>
      </LI>
      <LI>
        <a className="list-layout-view" href={Href}>
          <List onClick={() => dispatch(setGridView(false))} />
        </a>
      </LI>
    </UL>
  );
};
export default ViewBookmark;
